import type { CopyShape } from "@tami/core/intl";

import type { PERFORMANCE_SCRIPT_COPY_PT_BR } from "../performance-script.copy";

export const PERFORMANCE_SCRIPT_COPY_ES_ES: CopyShape<typeof PERFORMANCE_SCRIPT_COPY_PT_BR> = {
  perfIntro: {
    narrative: "Rendimiento del creator: sigue seguidores, engagement y la evolución de tus redes en un solo sitio.",
  },
  perfMonth: {
    narrative: "Navega mes a mes para comparar resultados y entender las tendencias a lo largo del tiempo.",
    callout: "Selector de mes — compara el rendimiento actual con periodos anteriores.",
  },
  perfSocial: {
    narrative: "Instagram, TikTok y el resto de redes conectadas — seguidores y tasa de engagement lado a lado.",
    callout: "Cada red con su usuario, base de seguidores y engagement actualizado.",
  },
  perfOverview: {
    narrative: "Los totales consolidados muestran el tamaño de tu audiencia y el engagement medio.",
  },
  perfAggregated: {
    narrative: "Total de seguidores, volumen de posts y engagement medio — KPIs que guían tu estrategia de contenido.",
    callout: "Métricas agregadas de todas las redes conectadas en el periodo.",
  },
  perfCharts: {
    narrative: "Las curvas de seguidores y engagement revelan picos, bajadas y el impacto de campañas o virales.",
    callout: "Gráficos de líneas por red — filtra Instagram, TikTok y otras en la leyenda.",
  },
};
